import { Deserializable } from '../deserializable';
import { User } from '../interfaces/user';
import { DirectCustomerNote } from './direct-customer-note.model';
import { DirectCustomerPasswordHistory } from './direct-customer-password-history.model';
import { DirectCustomerSecurityQuestion } from './direct-customer-security-question.model';
import { PropositionInterfaceType } from './proposition-interface-type.model';
import { Role } from './role.model';
import { UserActionHistory } from './user-action-history.model';

export class DirectCustomer implements Deserializable, User {
  public Id: number;
  public DirectCustomerID: number;
  public Title: string;
  public FirstName: string;
  public LastName: string;
  public ContactNumber: string;
  public EmailAddress: string;
  public DateOfRegistration?: Date;
  public DateCreated?: Date;
  public DateLastUsed?: Date;
  public FailedLoginCount?: number;
  public ChangePasswordAtNextLogon?: boolean;
  public DateStatusChanged?: Date;
  public ProposedEmailAddress: string;
  public PropositionID?: number;
  public PropositionName?: string;
  public EmailConfirmed?: boolean;
  public EmailConfirmationGuid?: string;
  public StatusCode: string;
  public IsAccountLockedOut?: boolean;
  public ReceiveCaseNotifications?: boolean;
  public RegistrationExpirationDate?: Date;
  public ResetPasswordGuid?: string;
  public ResetPasswordGuidExpirationDate?: Date;
  public DateLastPasswordReset?: Date;
  public FailedSecurityAnswerCount?: number;
  public HideNewFeatureVersion?: number;
  public IsAccountSuspended?: boolean;
  public WasWelcomeMessageSeen?: boolean;
  public AccessTokenGuid?: string;
  public OneTimeTokenGuid?: string;
  public LastUsedSecurityQuestionCode: string;
  public HasAcceptedCookiePolicy?: boolean;
  public WhereDidUserHearAboutProduct?: number;
  public OneTimeTokenAccessAttemptsCount?: number;
  public OneTimeTokenAccessTime?: Date;
  public SummitCustomerNumber?: number;
  public IsPhoneValidated?: boolean;
  public UserActionHistories: Array<UserActionHistory>;
  public DirectCustomerNotes: Array<DirectCustomerNote>;
  public DirectCustomerPasswordHistories: Array<DirectCustomerPasswordHistory>;
  public DirectCustomerSecurityQuestions: Array<DirectCustomerSecurityQuestion>;
  public Roles: Array<Role>;
  public PropositionInterfaceType: PropositionInterfaceType;
  public ShouldValidatePassword: boolean;
  public IsInProfileContext: boolean;
  public PasswordToHash: string;
  public ConfirmationPassword: string;
  public ConfirmationEmail: string;
  public IsNew: boolean;
  public PropositionLogoPath: string;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.PropositionName = input.Proposition.Name;
    this.DirectCustomerNotes = input.DirectCustomerNotes
      ? input.DirectCustomerNotes.map((note) => new DirectCustomerNote().deserialize(note))
      : [];

    return this;
  }
}
